type DeactivateEndpoint = 'delete' | 'deactivate';

interface GetCurrentContent {
  hookType: number;
  defaultValue: number;
  endpoint: 'delete' | 'deactivate';
  text: string;
  bodyText: string;
  title: string;
  dataLayerSection: string;
}

function getType(isDelete: boolean): DeactivateEndpoint {
  return isDelete ? 'delete' : 'deactivate';
}

export function getCurrentContent(isDelete: boolean): GetCurrentContent {
  if (isDelete)
    return {
      hookType: 0,
      defaultValue: 4,
      endpoint: getType(isDelete),
      text: 'deletar',
      bodyText: 'Essa ação é definitiva e não será possível recuperar o seu anúncio',
      title: 'excluir anúncio',
      dataLayerSection: 'modal excluir anúncio'
    };

  return {
    hookType: 1,
    defaultValue: -1,
    endpoint: getType(isDelete),
    text: 'desativar',
    bodyText: 'Essa ação é definitiva e você não poderá reativar o seu anúncio',
    title: 'desativar anúncio',
    dataLayerSection: 'modal desativar anúncio'
  };
}
